import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import {
  IAppleAdsUpdateRequest,
  IAppleAdsUpdateResponse,
} from "../../features/Campaigns/interface/appleAds";
import { useAuth } from "../helper/useAuth";

interface UseAppleAdsUpdateCampaignParams {
  campaignId: string | number;
  data: IAppleAdsUpdateRequest;
}

export const useAppleAdsUpdateCampaign = () => {
  const queryClient = useQueryClient();
  const { selectedIntegration } = useAuth();

  return useMutation<
    IAppleAdsUpdateResponse,
    Error,
    UseAppleAdsUpdateCampaignParams
  >({
    mutationFn: async ({ campaignId, data }) => {
      const url = API_CONFIG.path.appleAdsCampaignUpdate.replace(
        ":id",
        String(campaignId),
      );
      const queryParams = { tracking_id: selectedIntegration?.value as string };
      return httpService.post<IAppleAdsUpdateResponse, IAppleAdsUpdateRequest>(
        url,
        data,
        queryParams,
      );
    },
    onSuccess: (_, variables) => {
      // Invalidate the specific campaign detail query
      queryClient.invalidateQueries({
        queryKey: ["apple-ads-campaign-detail", String(variables.campaignId)],
      });
      // Also invalidate the campaigns list
      queryClient.invalidateQueries({
        queryKey: ["apple-ads-campaigns"],
      });
    },
  });
};
